export const MESSAGE_TYPE = {
  SEARCH: 'search',
  SEARCH_RESULT: 'search_result',
  FEEDBACK_REQUEST: 'feedback_request',
  AVAILABLE_TYPES: 'available_types',
  SELECT_TYPE: 'select_type',
  READY_TO_LISTEN: 'ready_to_listen',
  FEEDBACK_CONTENT: 'feedback_content',
  FEEDBACK_RECEIVED: 'feedback_received'
};
